import { createLanguageRegistrar } from "./languageBase";

/** Monarch language definition for HTTP request/response syntax. */
const httpDef: Record<string, unknown> = {
  tokenizer: {
    root: [
      [/^(GET|POST|PUT|DELETE|PATCH|HEAD|OPTIONS|CONNECT|TRACE)\b/, "keyword.http"],
      [/HTTP\/[\d.]+/, "keyword.http"],
      [/\b[1-5]\d{2}\b/, "number.http"],
      [/^([\w-]+)(:)/, ["attribute.name.http", "delimiter"]],
      [/^#[^\n]*/, "comment.http"],
      [/^\/\/[^\n]*/, "comment.http"],

      [/https?:\/\/\S+/, "string.link.http"],
      [/\/[\w./?&=%-]*/, "string.link.http"],
      [/"/, "string.http", "@string"],
      [/\d[\d.]*/, "number.http"],
      [/[?&][\w-]+=/, "variable.http"],
      [/[{}()[\]]/, "delimiter"],
      [/[,;]/, "delimiter"],
      [/\s+/, "white"],
    ],

    string: [
      [/[^\\"]+/, "string.http"],
      [/\\./, "string.escape.http"],
      [/"/, "string.http", "@pop"],
    ],
  },
};

/**
 * Registers a Monarch tokenizer for HTTP request/response syntax with Monaco.
 */
export const registerHTTP = createLanguageRegistrar({ id: "http", extensions: [".http", ".rest"] }, httpDef);
